const CartTitles = () => {
  return (
    <div className='cart__productTitle'>
      <h3 className='cart__productTitle-name'>Product</h3>
      <h3 className='cart__productTitle-price'>Price</h3>
      <h3 className='cart__productTitle-quantity'>Quantity</h3>
      <h3 className='cart__productTitle-total'>Total</h3>
    </div>
  )
}

export default CartTitles
